<template>
  <div
    class="ifttt-delay-time"
  >
    <div class="ifttt-delay-time_container">
      <el-time-picker
        v-model="hourVal"
        :editable="true"
        class="timedata_input"
        format="HH"
        value-format="HH"
        popper-class="only_hour"
        :clearable="false"
      />
      <em class="time_text">{{ $t('iftttset.hour') }}</em>
      <el-time-picker
        v-model="minuteVal"
        :editable="true"
        class="timedata_input"
        format="mm"
        value-format="mm"
        popper-class="only_minute"
        :clearable="false"
      />
      <em class="time_text">{{ $t('iftttset.minutes') }}</em>
      <el-time-picker
        v-model="secondVal"
        :editable="true"
        class="timedata_input"
        format="ss"
        value-format="ss"
        popper-class="only_second"
        :clearable="false"
      />
      <em class="time_text">{{ $t('iftttset.second') }}</em>
    </div>
    <div
      class="ifttt-delay-time_btnList"
    >
      <div
        type="primary"
        class="ifttt-delay-time_btn ok"
        @click="onSubmit"
      >
        {{ $t('iftttset.sure') }}
      </div>
      <div
        class="ifttt-delay-time_btn cancel"
        @click="handlerClose"
      >
        {{ $t('iftttset.cancle') }}
      </div>
    </div>
  </div>
</template>

<script>
import {Close, Open} from "@/axios/IFttt";
import {alerterror, alertsuccess} from "@assets/common";
import vSwith from '@/components/common/switch.vue';

export default {
  components: { vSwith },
  props: {
    
  },
  data () {
    return {
      hourVal: '00',
      minuteVal: '00',
      secondVal: '01',
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onSubmit() {
      const emitData = {
        renderData: {
          type: 1,
          value: {
            hourVal: Number(this.hourVal),
            minuteVal: Number(this.minuteVal),
            secondVal: Number(this.secondVal),
          },
          text: `${this.$t('ifttt.delayed')} ${this.hourVal} ${this.$t('iftttset.hour')} ${this.minuteVal} ${this.$t('ifttt.minute')} ${this.secondVal} ${this.$t('iftttset.second')}`
        },
        ExecuteTaskData: {
          ActionType: 1,
          DelayTime: 10870
        }
      }

      this.$emit('change', emitData);
      this.handlerClose();
    },

    handlerClose() {
      this.$emit('onHide');
    }
  }
}
</script>

<style lang="scss" scoped>
 .ifttt-delay-time {
  &_container {
    display: flex;
    align-items: center;
    justify-content: center;

    .el-date-editor.el-input {
      width: 20%;
      margin: 0 10px;
    }
  }

  &_btnList {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 62px;
  }

  &_btn {
    width: 140px;
    height: 40px;
    border-radius: 3px;
    background: transparent;
    margin: 0 30px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  
    &.ok {
      background: #0046aa;
      color: #fff;
    }

    &.cancel {
      background: transparent;
      color: #0046aa;
      border: 1px solid #0046aa;
    }
  }
 }
</style>
